/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


/*(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
*/


$(document).ready(function () { 
  $(document).on('click', '.js-next_quiz', function (e) {
    e.preventDefault();

    let current_quiz = $(this).closest('.quiz'),
      quiz_next = $(this).attr('data-next'),
      quiz_name = current_quiz.attr('data-quiz');

    let selected_answer = $(this).attr('data-answer');
    if (selected_answer == 'under-12') {
      $('[data-answer="female"]').attr('data-next', 'quiz_5');
    }
    
    $(this).siblings('.selected').removeClass('selected');
    $(this).addClass('selected');

    current_quiz.removeClass('visible');
    $('.quiz.' + quiz_next).addClass('visible');
  });

  $(document).on('click', '.js-back_quiz', function (e) {
    e.preventDefault();

    let quiz_back = $(this).attr('data-back');

    $(this).closest('.quiz').removeClass('visible');
    $('.quiz.' + quiz_back).addClass('visible');
  });

  $(document).on('click', '.js-save_answers', function (e) {
    e.preventDefault();
    
    let logged_in_customer = $(this).attr('data-logged-in-customer-id');

    let answer_quiz1 = $('.quiz_1 .quiz-item.selected').attr('data-answer'),
        answer_quiz2 = $('.quiz_2 .quiz-item.selected').attr('data-answer'),
        answer_quiz3 = $('.quiz_3 .quiz-item.selected').attr('data-answer'),
      answer_quiz4 = 'no';
    
    let firstname = $('.profile_form input#klaviyo_FirstName').val();
    
    if ($('.quiz_4 .quiz-item.selected').length > 0) {
      answer_quiz4 = $('.quiz_4 .quiz-item.selected').attr('data-answer');
    }
  
    let recipeAnswers = {
      skin_type: answer_quiz1,
      old: answer_quiz2,
      gender: answer_quiz3,
      pregnancy: answer_quiz4
    };

    localStorage.setItem('recipeAnswers', JSON.stringify(recipeAnswers));
    localStorage.setItem('recipeUrl', window.Shopify.routes.root+'pages/recipe-results?skin_type='+answer_quiz1+'&old='+answer_quiz2+'&gender='+answer_quiz3+'&pregnancy='+answer_quiz4+'&firstname='+firstname);

    if (typeof logged_in_customer !== 'undefined' && logged_in_customer !== false) {
      fetch('/apps/custom-metafields', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(recipeAnswers)
      }).then((data) => {
        window.location.href = '/pages/myroutine';
      }).catch((error) => {
        console.error('Error:', error);
      });
    } else {
      let formData = $(this).closest('form#routine_builder_signup');

      const options = {
        method: 'POST',
        headers: { accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          data: '{"token": "QSB4ZZ", "event": "Personalised SkinB5 Routine", "customer_properties": {"$email": "' + formData.find('#klaviyo_email').val() + '"}, "properties": {"Skin_type": "' + answer_quiz1 + '","Age": "' + answer_quiz2 + '","Gender": "' + answer_quiz3 + '","Pregnancy": "' + answer_quiz4 + '"}}'
        })
      };

      fetch('https://a.klaviyo.com/api/track', options)
        .then(response => response.json())
        .then(response => console.log(response))
        .catch(err => console.error(err));

      let settings = {
        async: true,
        crossDomain: true,
        url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        data: {
          g: formData.find('input[name="g"]').val(),
          email: formData.find('#klaviyo_email').val(),
          $source: 'Routine builder',
          $fields: '$consent, $first_name, $last_name, $phone_number, Skin_type, Age, Gender, Pregnancy',
          $first_name: formData.find('#klaviyo_FirstName').val(),
          $last_name: formData.find('#klaviyo_LastName').val(),
          $phone_number: formData.find('#klaviyo_Phone').val(),
          Skin_type: answer_quiz1,
          Age: answer_quiz2,
          Gender: answer_quiz3,
          Pregnancy: answer_quiz4
        }
      }

      let current_quiz = $(this).closest('.quiz'),
          quiz_next = $(this).attr('data-next');

      $.ajax(settings).done(function (response) {       
        current_quiz.removeClass('visible');
        $('.quiz.' + quiz_next).addClass('visible');
      });
    }
  });

  $('.products_routine__subscription').on('click', 'input[type=radio][name=selling-plan-group]', function (e) {

    let checked_selling_plan_group = $(".products_routine__subscription input[name=selling-plan-group]:checked").val();

    $('.products_routine__subscription .product__subs__group').removeClass('selected');
    $('.products_routine__subscription input[type=radio][name=selling-plan-group]').prop("checked", false).removeAttr('checked');
    $(this).prop("checked", true).attr('checked', true);
    $(this).closest('.product__subs__group').addClass('selected');

    if (checked_selling_plan_group) {
      $('.product__subs__plans__select[data-group-toggle='+ checked_selling_plan_group +']').removeClass('hide');
    } else {
      $('.product__subs__plans__select').addClass('hide');
    }
  });

  $(document).on('click', '.js-add_products_recipe', function (e) {
    e.preventDefault();

    let formData = {
			'items': []
    }

    let selling_plan = '';

    let product__subs__group = $('.products_routine__subscription .product__subs__group.selected').attr('data-selling-plan-group');
    if (typeof product__subs__group !== 'undefined' && product__subs__group !== false) {
      selling_plan = $('.products_routine__subscription [name="selling_plan"]').val();
    }

    let products_recipe = $('.recipe_results--products_form').find('.products_form--item');
    
    products_recipe.each(function( index ) {
      let product_id = $(this).attr('data-product-id');
      if (typeof product_id !== 'undefined' && product_id !== null) { 
        formData.items.push({
					quantity: 1,
          id: product_id,
          selling_plan: selling_plan
				});
      }
    });

    fetch(`${window.theme.routes.cart}/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            detail: {
              cart: response.data,
            },
            bubbles: true,
          })
        );
        $('[data-drawer-toggle="drawer-cart"]').trigger('click');
        if ($('[data-ajax-disable="true"]').length > 0) {
          window.location.reload();
        }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  $('#create_customer').on('click', '.js_register_after_quiz', function (e) {
    e.preventDefault();

    let recipeUrl;
    
    if (window.localStorage) {
      localStorage.setItem('save_quiz', true);

      recipeUrl = localStorage.getItem('recipeUrl');
    }

    if (recipeUrl) {
      $(this).closest('form').append('<input type="hidden" name="return_to" value="'+recipeUrl+'">');
    }
    
     $(this).closest('form').submit();
  });
  
  $(document).on('click', '.js-redirect_recipe_results', function (e) {
    e.preventDefault();

    let recipeUrl;
    
    if (window.localStorage) {
      recipeUrl = localStorage.getItem('recipeUrl');
    }

    if (recipeUrl) {
      window.location.href = recipeUrl;
    }
  });
  
  $(document).on('click', '.js-show_recipeAnswers', function (e) {
    e.preventDefault();

    let modal = $(this).attr('data-popup');
    $('#' + modal).addClass('is-open');
    $('#' + modal).attr('aria-hidden', false);
  });

  $(document).on('click', '.js-modal__close', function (e) {
    e.preventDefault();

    let modal = $(this).closest('.modal');
    modal.removeClass('is-open');
    modal.attr('aria-hidden', true);
  });

  $(document).on('click', '.js-edit_recipeAnswers', function (e) {
    e.preventDefault();
    
    let logged_in_customer = $(this).attr('data-logged-in-customer-id');
    let formEdit = $(this).closest('.form_edit_recipeAnswers');

    let answer_quiz1 = formEdit.find('select#skin_type').val(),
        answer_quiz2 = formEdit.find('select#old').val(),
        answer_quiz3 = formEdit.find('select#gender').val(),
        answer_quiz4 = formEdit.find('select#pregnancy').val();

    let firstname = $('#recipe_results .customer_name span').text();

    let recipeAnswers = {
      skin_type: answer_quiz1,
      old: answer_quiz2,
      gender: answer_quiz3,
      pregnancy: answer_quiz4 ? answer_quiz4 : 'no'
    };

    localStorage.setItem('recipeAnswers', JSON.stringify(recipeAnswers));
    localStorage.setItem('recipeUrl', window.Shopify.routes.root+'pages/recipe-results?skin_type='+answer_quiz1+'&old='+answer_quiz2+'&gender='+answer_quiz3+'&pregnancy='+answer_quiz4+'&firstname='+firstname);

    if (typeof logged_in_customer !== 'undefined' && logged_in_customer !== false) {
      fetch('/apps/custom-metafields', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(recipeAnswers)
      }).then((data) => {
        window.location.reload();
      }).catch((error) => {
        console.error('Error:', error);
      });
    } else {
      window.location.href = window.Shopify.routes.root+'pages/recipe-results?skin_type='+answer_quiz1+'&old='+answer_quiz2+'&gender='+answer_quiz3+'&pregnancy='+answer_quiz4+'&firstname='+firstname;
    }
  });
  
  $(document).on('click', '.js-open_signIn', function (e) {
    e.preventDefault();

    if (window.localStorage) {
      localStorage.setItem("recipeSignIn", true);
    }

    let recipeUrl = $(this).attr('href');
    window.location.href = recipeUrl;
  });

  $('#customer_login').on('click', '[type="submit"]', function (e) {
    e.preventDefault();

    let recipeSignIn = localStorage.getItem('recipeSignIn');
    
    if (recipeSignIn) {    
      if (window.localStorage) {
        localStorage.setItem('save_quiz', true);
      }

      $(this).closest('form').append('<input type="hidden" name="checkout_url" value="pages/myroutine">');
    }

    $(this).closest('form').submit();
  });

  // $("#recipe_builder-newsletter #customer_Email").on("keyup change", function (e) {
  //   let email = $(this).val();
  //   if (email && IsEmail(email)==true) {
  //     $('.js-save_answers').prop("disabled", false);
  //   }
  // });
});

function IsEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

class Drawer{
  constructor(register__drawer) {
    this.drawer = register__drawer;
    this.drawerScrolls = this.drawer.querySelector("[data-drawer-scrolls]");
    this.underlay = this.drawer.querySelector("[data-drawer-underlay]")
    this.key = this.drawer.dataset.drawer;
    this.buttons = document.querySelectorAll(`[data-drawer-toggle='${this.key}']`);
    this.staggers = this.drawer.querySelectorAll("[data-stagger-animation]");

    this.connectToggle();
    this.connectDrawer();
    this.closers();
    this.staggerChildAnimations();
  }

  unload() { }

  connectToggle() {
    this.buttons.forEach((t) => {
      t.addEventListener(
        "click",
        function (t) {
          t.preventDefault(),
            this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:toggle", {
                bubbles: !1,
              })
            );
        }.bind(this)
      );
    });
  }

  connectDrawer() {
    this.drawer.addEventListener(
      "theme:drawer:toggle",
      function () {
        this.drawer.classList.contains('drawer--visible')
          ? this.drawer.dispatchEvent(
            new CustomEvent("theme:drawer:close", {
              bubbles: !1,
            })
          )
          : this.drawer.dispatchEvent(
            new CustomEvent("theme:drawer:open", {
              bubbles: !1,
            })
          );
      }.bind(this)
    ),
      this.drawer.addEventListener(
        "theme:drawer:close",
        this.hideDrawer.bind(this)
      ),
      this.drawer.addEventListener(
        "theme:drawer:open",
        this.showDrawer.bind(this)
      );
  }

  staggerChildAnimations() {
    this.staggers.forEach((t) => {
      t.querySelectorAll(":scope > * > [data-animates]").forEach(
        (t, e) => {
          t.style.transitionDelay = 50 * e + 10 + "ms";
        }
      );
    });
  }

  closers() {
    this.drawer.addEventListener(
      "keyup",
      function (t) {
        t.which === window.theme.keyboardKeys.ESCAPE &&
          (this.hideDrawer(), this.buttons[0].focus());
      }.bind(this)
    ),
      this.underlay.addEventListener(
        "click",
        function () {
          this.hideDrawer();
        }.bind(this)
      );
  }

  showDrawer() {
    this.drawer.classList.remove('display-none'),
      setTimeout(() => {
        this.buttons.forEach((t) =>
          t.setAttribute("aria-expanded", !0)
        ),
          this.drawer.classList.add('drawer--visible'),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
              detail: this.drawerScrolls,
            })
          );
      }, 1);
  }

  hideDrawer() {
    this.buttons.forEach((t) =>
      t.setAttribute("aria-expanded", !0)
    ),
      this.drawer.classList.remove('drawer--visible'),
      this.drawerScrolls.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
      ),
      document.dispatchEvent(
        new CustomEvent("theme:sliderule:close", { bubbles: !1 })
      ),
      setTimeout(() => {
        this.drawer.classList.contains('drawer--visible') ||
          this.drawer.classList.add('display-none');
      }, 800);
  }
};

let register__drawer = document.querySelector('[data-drawer="quiz-register"]');
if (register__drawer) {
  new Drawer(register__drawer);
}

// auto select tag - Landing page - store locator section
if (document.body.classList.contains('template_page_landing') && document.getElementById('filter-promap')) {
  let filter_tag = document.getElementById('filter-promap').getAttribute('data-filter-map')
  // console.log(filter_tag);
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const filterElementProMap = document.querySelector(`[value=${filter_tag}]`)
        if (filterElementProMap) {
          if (filterElementProMap.checked == false) {
            filterElementProMap.checked = true;
          }
        }
      }
    
    });
  });

  const parentElement = document.getElementById('scasl-app-container'); 
  const config = { childList: true, subtree: true }; 
  observer.observe(parentElement, config);

}